<template>
  <div class="card-header">
    <span>{{ notSubmittedBooks.department.deptCode }} {{ notSubmittedBooks?.course?.sisCourseId?.substring(0, 8) }} | {{
        notSubmittedBooks.course.name
    }}
    </span>
    <div class="float-end">
      <span class="v-a-super">Not Submitted</span>&nbsp;
      <span class="material-icons text-warning" title="Not Submitted">error</span>
    </div>
  </div>
  <div class="accordion" :id="'accordionExample' + notSubmittedBooks?.course?.sisCourseId">
    <div class="accordion-item">
      <h2 class="accordion-header fw-bold">
        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
          :data-bs-target="'#collapseOne' + notSubmittedBooks?.course?.sisCourseId" aria-expanded="false"
          aria-controls="collapseOne" @click="getSectionsOfTermNCourse(termId)">
          I'd like to re-adopt from a past adoption
        </button>
      </h2>
      <div :id="'collapseOne' + notSubmittedBooks?.course?.sisCourseId" class="accordion-collapse collapse"
        :data-bs-parent="'#accordionExample' + notSubmittedBooks?.course?.sisCourseId">
        <div class="accordion-body">
          <div class="row">
            <div class="col-sm-3 mb-3 msg-content">
              <span class="fw-bold">Using the same materials as:</span>
            </div>
            <div class="col-sm-2 mb-3">
              <label for="Schools">Term:</label>
              <select class="form-select" v-model="termId" @change="getSectionsOfTermNCourse(termId)">
                <option value="null" disabled>Select Term</option>
                <option v-for="termName in this.terms" :key="termName.termName" :value="termName.termId">
                  {{ termName.termName }}
                </option>
              </select>
            </div>
            <div class="col-sm-4 mb-3">
              <label for="Schools">Section:</label>
              <select class="form-select" v-model="sectionId" @change="getAdoptionsOfSection(sectionId)">
                <option value="null" disabled>Select Section</option>
                <option v-for="section in this.sections" :key="section.sectionName" :value="section.sectionId">
                  {{ section.departmentCode }}
                  {{ section.sectionName.substring(0, 5) }}
                  {{ section.sectionNumber }}:
                  {{ section.instructorName }}
                </option>
              </select>
            </div>
            <div class="checkcourses">
              <div class="input-group mb-3" v-if="adoptions != null">
                <!-- <div class="input-group-text">
                  <input class="form-check-input mt-0" type="checkbox" value=""
                    aria-label="Checkbox for following text input" />
                </div> -->

                <div class="form-control" v-if="adoptions.length > 0">
                  <CourseCards :adoptions="this.adoptions" :flag='2' @removeAdoption="removeAdoption($event)"
                    @selectedAdoptions="selectionChange($event)" />
                </div>
                <div v-else class="message-adoption">
                  <h5><i>No previous adoptions!!</i></h5>
                </div>
              </div>
              <div class="float-end">
                <button type="button" class="btn btn-primary me-2" @click="addBooksFromAdoption()"
                  :disabled="selectedAdoptions.length == 0">
                  <span class="material-icons-outlined btn-icon"> check_circle </span>
                  One click Re-Adopt
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
    <div class="accordion-item">
      <h2 class="accordion-header">
        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" @click="clearAdoptions()"
          :data-bs-target="'#collapseTwo' + notSubmittedBooks?.course?.sisCourseId" aria-expanded="false"
          aria-controls="collapseTwo">
          I'd like to be guided through the adoption process
        </button>
      </h2>
      <div :id="'collapseTwo' + notSubmittedBooks?.course?.sisCourseId" class="accordion-collapse collapse"
        :data-bs-parent="'#accordionExample' + notSubmittedBooks?.course?.sisCourseId">
        <div class="accordion-body">
          <!-- <AdoptionGuide :submittedBooks="notSubmittedBooks" :flag="notSubmittedBooks.course.sisCourseId"/> -->

          <div class="card guide">
            <button class="btn btn-beige" type="button" data-bs-toggle="collapse" data-bs-target="#collapseGuide"
              aria-expanded="false" aria-controls="collapseGuide">
              <span class="float-start">View Detailed Adoption History</span>
            </button>
            <div class="collapse card card-body" id="collapseGuide">
              <div class="">
                <button class="btn btn-secondary form-control" type="radio">
                  <input class="form-check-input float-start" type="radio" value="term" @change="clearAdoptions()"
                    v-model="detailedAdoptionOption" />
                  <div class="row">
                    <div class="col-sm-6">
                      <span class="float-start">History of {{ notSubmittedBooks.course.name }} </span>
                    </div>
                    <div class="col-sm-3 mb-3">
                      <div class="row">
                        <div class="col-sm-3">
                          <label for="Terms">Term:</label>
                        </div>
                        <div class="col-sm-9">
                          <select class="form-select btn-sm" v-model="detailTermId"
                            :disabled="(detailedAdoptionOption !== 'term')" @change="getAdaptionsByTerm(termId)">
                            <option value="null" disabled>Select Term</option>
                            <option v-for="termName in terms" :key="termName.termName" :value="termName.termId">
                              {{ termName.termName }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </button>
                <div v-if="detailedAdoptionOption == 'term'">
                  <div v-if="(detailedAdoptionOption == 'term') && this.adoptions != null && this.adoptions.length > 0">
                    <CourseCards :adoptions="adoptions" :flag='2' @removeAdoption="removeAdoption($event)"
                      @selectedAdoptions="selectionChange($event)" />
                  </div>
                  <div v-else-if="detailTermId == null" class="message">
                    <h5><i>Please select term!!</i></h5>
                  </div>
                  <div v-else class="message-adoption">
                    <h5><i>No Previous Adoptions!!</i></h5>
                  </div>
                  <div>

                  </div>
                </div>
              </div>
              <hr>
              <div class="">
                <button class="btn btn-secondary form-control" type="radio">
                  <input class="form-check-input float-start" type="radio" value="course"
                    v-model="detailedAdoptionOption"
                    @change="getCoursesByDept(notSubmittedBooks.department.id); clearAdoptions()" />
                  <div class="row">
                    <div class="col-sm-4">
                      <span class="float-start">History Of
                        {{ notSubmittedBooks.department.name }}/{{ notSubmittedBooks.department.id }} </span>
                    </div>
                    <div class="col-sm-5">
                      <div class="row">
                        <div class="col-sm-3">
                          <label for="Course">Course:</label>
                        </div>
                        <div class="col-sm-9">
                          <select class="form-select btn-sm" v-model="detailCourseId"
                            :disabled="(detailedAdoptionOption !== 'course')"
                            @change="getTermsByCourses(notSubmittedBooks.course.sisCourseId)">
                            <option value="null" disabled>Select Course</option>
                            <option v-for="item in filteredCourses" :key="item.name" :value="item">
                              {{ item.name }}
                            </option>
                          </select>
                        </div>
                        <!-- <div class="dropdown">
                          <button type="button" class="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown"
                            aria-expanded="false" data-bs-auto-close="outside">
                            Dropdown form
                          </button>
                          <div class="dropdown-menu">
                            <div class="dropdown-header">
                              <form>
                              <input type="text" class="form-control" placeholder="Search.." v-model="searchKwd"
                                v-on:keyup="filterCourseDropdown(searchKwd)">
                              </form>
                            </div>
                          </div>
                          <div class="dropdown-item">
                            <option v-for="item in filteredCourses" :key="item.name" :value="item">
                                {{ item.name }}
                            </option>
                          </div>
                        </div> -->
                      </div>
                    </div>
                    <div class="col-sm-3">
                      <div class="row">
                        <div class="col-sm-3">
                          <label for="Terms">Term:</label>
                        </div>
                        <div class="col-sm-8">
                          <select class="form-select btn-sm" v-model="courseTermId"
                            :disabled="(detailedAdoptionOption !== 'course')" @change="getAdaptionsByTermCourse()">
                            <option value="null" disabled>Select Term</option>
                            <option v-for="item in courseTerms" :key="item.name" :value="item.id">
                              {{ item.name }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </button>
                <div v-if="detailedAdoptionOption == 'course'">
                  <div v-if="(detailedAdoptionOption == 'course') && this.adoptions != null">
                    <div>
                      <CourseCards :adoptions="this.adoptions" :flag='2' @removeAdoption="removeAdoption($event)"
                        @selectedAdoptions="selectionChange($event)" />
                    </div>
                  </div>
                  <div class="message" v-else-if="detailCourseId == null && courseTermId == null">
                    <h5><i>Please select course and term!!</i></h5>
                  </div>
                  <div class="message" v-else-if="courseTermId == null">
                    <h5><i>Please select term!!</i></h5>
                  </div>
                  <div class="message" v-else-if="detailCourseId == null">
                    <h5><i>Please select course!!</i></h5>
                  </div>
                  <div class="message-adoption" v-else>
                    <h5><i>No Previous adoptions!!</i></h5>
                  </div>
                </div>
                <div class="float-end mt-2">
                  <button type="button" class="btn btn-primary me-2" :disabled="selectedAdoptions.length == 0"
                    @click="addBooksFromAdoption()">
                    <span class="material-icons-outlined btn-icon"> check_circle </span>
                    Add to Course
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="card guide">
            <button class="btn btn-beige" type="button" data-bs-toggle="collapse" data-bs-target="#collapseGuide2"
              aria-expanded="false" aria-controls="collapseGuide2">
              <span class="float-start">Search by ISBN or Keyword</span>
            </button>
            <div class="card suggestion-card collapse" id="collapseGuide2">
              <label class="form-control-label" for="form-control-search">
                <p class="text-primary"><b>Search Materials</b></p>
              </label>
              <!-- <div v-if="coursedetails"></div> -->
              <div>
                <AdSearch :coursedetails="notSubmittedBooks.course.sections[0].id" @useTheBook="useTheBook($event)"
                  @saveBookAdoption="saveNewBook" />

              </div>
            </div>
          </div>


        </div>
      </div>
    </div>
    <div class="accordion-item">
      <h2 class="accordion-header">
        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" @click="clearAdoptions()"
          :data-bs-target="'#collapseThree' + notSubmittedBooks?.course?.sisCourseId" aria-expanded="false"
          aria-controls="collapseThree">
          I'm not using any materials for this class.
        </button>
      </h2>
      <div :id="'collapseThree' + notSubmittedBooks?.course?.sisCourseId" class="accordion-collapse collapse"
        :data-bs-parent="'#accordionExample' + notSubmittedBooks?.course?.sisCourseId">
        <div class="accordion-body row">
          <form class="col-sm-8">
            <div class="mb-3">
              <label for="exampleInputNotes" class="form-label"><b>Notes:</b><i>(Optional)</i></label>
              <!-- <input type="text" class="form-control" id="exampleInputNotes" aria-describedby="notesHelp"
                v-model="notes" /> -->
              <vue-editor v-model="notes" :editorToolbar="customToolbar"></vue-editor>
              <div id="textHelp" class="form-text">
                If you don't have any notes, Please click "Submit Adoption" button directly.
              </div>
            </div>
          </form>
          <div class="col-sm-4 btn-submit">
            <button type="button" class="btn btn-primary submitBtn float-end" @click="updateNoMaterialsRequired()">
              Submit Adoption
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VueEditor } from "vue3-editor";
import CourseCards from "../Faculty/CourseCards.vue";
import AdSearch from '../Faculty/SearchComponent.vue';
const _ = require('lodash');
export default {
  name: "NotSubmittedCard",
  props: {
    notSubmittedBooks: [],

    selectedTermId: {
      type: [String],
      default: null
    }

  },
  data() {
    return {
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        [{
          align: ""
        },
        {
          align: "center"
        },
        {
          align: "right"
        },
        {
          align: "justify"
        }],
        ["bold", "italic", "underline", "link"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ indent: "-1" }, { indent: "+1" }]
      ],
      isDropdownVisible: false,
      adoptionsbyinstructor: [],
      termId: null,
      courses: [],
      filteredCourses: [],
      result: [],
      adoptions: [Object],
      searchKwd: "",
      selectedcourse: String,
      termdata: '',
      terms: [],
      sections: [],
      sectionId: null,
      detailedAdoptionOption: "term",
      selectedAdoptions: [],
      detailTermId: null,
      detailCourseId: null,
      courseTermId: null,
      courseTerms: [],
      notes: ''
    };
  },
  methods: {
    getPreviousTerms(courseNo) {
      this.$store.dispatch("previousTerms", courseNo.substring(0, 5)).then((response) => {
        this.terms = response['data'];
        this.termId = this.terms[0]?.termId;
      })
    },

    getPreviousTermsForTermId(courseNo, selectedTermId = null) {
      const payload = {
        courseNumber: courseNo.substring(0, 5),
        selectedTermId: selectedTermId, // null if not passed
      };

      this.$store.dispatch("getPreviousTermsForTermId", payload).then((response) => {
        this.terms = response['data'];
        this.termId = this.terms[0]?.termId;
      });
    },
    myDropdownToggler() {
      this.isDropdownVisible = !this.isDropdownVisible;
    },
    filterCourseDropdown(event) {
      this.filteredCourses = this.courses.filter(x => x.name.toUpperCase().includes(event.toUpperCase()));
    },
    getTermsByCourses(sisCourseId) {
      this.courseTermId = null;
      this.adoptions = null;
      this.$store.dispatch("getTermsByCourses", sisCourseId.substring(0, 5)).then((res) => {

        this.courseTerms = res.data.data;

      })
    },
    updateNoMaterialsRequired() {
      var con = { "sectionId": this.notSubmittedBooks.course.sections[0].id, "isNoMaterialsRequired": true, "notes": this.notes }
      this.$store.dispatch("removeAdoptionbySection", con).then(() => {
        this.getCourses();
      })
    },
    getAdaptionsByTerm(termId) {
      this.$store.dispatch("getAdoptionsByTerm", { "courseId": this.notSubmittedBooks.id, "courseNumber": this.notSubmittedBooks.course.sisCourseId.substring(0, 5), "termId": termId })
        .then((res) => {
          if (res.data) {
            this.adoptions = res.data.map(x => x.adoptions)[0];
          }
          else {
            this.adoptions = [];
          }
        })
    },
    clearAdoptions() {
      this.adoptions = null;
      this.detailTermId = null;
      this.courseTermId = null;
      this.detailCourseId = null;
      this.selectedAdoptions = [];
    },
    getAdaptionsByTermCourse() {
      this.$store.dispatch("getAdoptionsByTermCourse", { "courseId": this.detailCourseId.id, "courseNumber": this.detailCourseId.sisCourseId.substring(0, 5), "termId": this.courseTermId })
        .then((res) => {
          if (res.data) {
            this.adoptions = res.data.map(x => x.adoptions)[0];
          }
          else {
            this.adoptions = [];
          }
        })

    },
    useTheBook(adoption) {
      this.$store.dispatch("usePreviousBook", adoption).then(() => {
        this.getCourses();
      });
    },
    getCoursesByDept(deptId) {
      this.$store.dispatch("getCoursesByDept", deptId).then((res) => {

        this.filteredCourses = this.courses = _.orderBy(res.data.data, ['name'], ['asc']);
        // this.courses = res.data.data;
      })
    },
    getSectionsOfTermNCourse(termId) {
      if (!termId) {
        return;
      }
      this.sections = this.terms.filter(x => x.termId == termId)[0].sections;
      this.sectionId = this.sections[0].sectionId
      this.getAdoptionsOfSection(this.sectionId);
    },
    selectionChange(selectedAdoptions) {
      this.selectedAdoptions = this.adoptions.filter(x => selectedAdoptions.includes(x.id));
    },
    removeAdoption(adoptionId) {
      let savedAdoptions = this.adoptions;
      this.adoptions = null;
      this.adoptions = savedAdoptions.filter(x => x.adoptionId !== adoptionId);
    },
    getAdoptionsOfSection(sectionId) {
      this.$store.dispatch("getAdoptionsbysections", [sectionId]).then((response) => {
        this.adoptions = response.data[0].adoptions;
      })
    },
    stringToBoolean(str) {
    return str.toLowerCase() === 'true';
   },
    addBooksFromAdoption() {
      let selectionAdoptions = [];
      selectionAdoptions = this.selectedAdoptions;
      selectionAdoptions.forEach(x => {
        x.suggestion = parseInt(x.suggestion);
        if (typeof x.isWaitToPurchase === 'string') {
          x.isWaitToPurchase = this.stringToBoolean(x.isWaitToPurchase);
        }
        //x.isWaitToPurchase = this.stringToBoolean(x.isWaitToPurchase);
        delete x.book;
      });
      this.$store.dispatch("addFromPreviousAdoptions", { sectionId: this.notSubmittedBooks.course.sections[0].id, adoptions: selectionAdoptions }).then(() => {
        this.getCourses();
      });
    },
    getadaptiondetails() {
      this.$store.dispatch("getAdoptionsbysections", [this.selectedcourse.sectionId]).then((res) => {
        this.adoptions = res.data[0].adoptions;
      });
    },
    getCourses() {
      this.$emit('getCourseBooks');
    },
    saveNewBook() {
      this.getCourses();
    }
  },
  mounted() {
    const courseNumber = this.notSubmittedBooks.course.sisCourseId;
    if (this.selectedTermId) {
      this.getPreviousTermsForTermId(courseNumber, this.selectedTermId);
    } else {
      this.getPreviousTermsForTermId(courseNumber);
    }
  },
  components: {
    CourseCards,
    AdSearch,
    VueEditor
  },
};
</script>

<style scoped>
.msg-content {
  align-items: center;
  padding-left: 30px;
  display: flex;
}

.card-header,
.card-footer {
  background-color: #f1f9f6d6;
}

.suggestion-card {
  margin: 0px 0px 15px 0px;
  padding: 15px;
}

.notes-card {
  margin: 10px 0px 15px 0px;
  padding: 15px;
}

.submitBtn {
  margin-top: 30px;
}

.message {
  padding-left: 15px;
  color: #ff3300;
}

.btn-submit {
  display: flex;
  align-items: end;
  justify-content: end;
  margin-bottom: 15px;
}

.message-adoption {
  padding-left: 15px;
  color: #23f514;
}

.v-a-super{
  vertical-align: super;
}
</style>